import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { ExternalLinkAltIcon } from "@patternfly/react-icons";

import { insuranceDocuments } from "./data/insuranceDocuments";

const InsurancePage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={10}
              offset={1}
              md={8}
              mdOffset={2}
            >
              <Stack hasGutter>
                <StackItem>
                  <Content
                    component="h1"
                    style={{ textAlign: "center" }}
                  >
                    Ubezpieczenia
                  </Content>
                </StackItem>

                <StackItem>
                  <Content
                    component="p"
                    style={{ textAlign: "center" }}
                  >
                    Informacje i dokumenty dotyczące ubezpieczenia
                    NNW uczniów.
                  </Content>
                </StackItem>
              </Stack>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardTitle>
                  Ubezpieczenia NNW
                </CardTitle>

                <CardBody>
                  <Content>
                    <List isPlain>
                      {insuranceDocuments.map((document) => (
                        <ListItem key={document.id}>
                          <a
                            href={document.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {document.title}{" "}
                            <ExternalLinkAltIcon />
                          </a>
                        </ListItem>
                      ))}
                    </List>
                  </Content>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default InsurancePage;